import type { ITransaction } from "@/modules/transaction/common/types";
import { Currencies } from "@/shared/common/enums";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface TransactionState {
  transaction?: ITransaction | null;
  rowId?: string | null;
  groupTransferCurrency: Currencies | null;
}

const initialState: TransactionState = {
  transaction: null,
  rowId: "",
  groupTransferCurrency: Currencies.AMD,
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    setRowId(state, { payload }: PayloadAction<{ rowId?: string | null } | null>) {
      state.rowId = payload?.rowId;
    },
    setGroupTransferCurrency(state, { payload }: PayloadAction<Currencies>) {
      state.groupTransferCurrency = payload;
    },
    setTransaction(
      state,
      { payload }: PayloadAction<{ transaction?: ITransaction | null } | null>
    ) {
      state.transaction = payload?.transaction;
    },

  },
});

export const {
  setRowId,
  setTransaction,
  setGroupTransferCurrency,
} = transactionSlice.actions;
export default transactionSlice.reducer;
